import { createReducer, on } from '@ngrx/store';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import * as A from './ministry-sector-services-summary.actions';

export const ministrySectorServicesSummaryFeatureKey = 'ministrySectorServicesSummary';

export interface MinistryServiceRegSummary {
  ministry: { id: string | number; ministryUniqueId?: string; ministryName?: string };
  totalServices: number;
  equivalentPercentage: number;
  draftServices: number;
  submittedServices: number;
  approvedServices: number;
  rejectedServices: number;
}

export interface SectorServiceRegSummary {
  sector: { id: string | number; sectorUniqueId?: string; sectorName?: string };
  totalServices: number;
  equivalentPercentage: number;
  draftServices: number;
  submittedServices: number;
  approvedServices: number;
  rejectedServices: number;
}

export interface State {
  ministry: EntityState<MinistryServiceRegSummary>;
  sector: EntityState<SectorServiceRegSummary>;
}

export const ministryAdapter: EntityAdapter<MinistryServiceRegSummary> =
  createEntityAdapter<MinistryServiceRegSummary>({
    selectId: (x) => x?.ministry?.id as any,
  });

export const sectorAdapter: EntityAdapter<SectorServiceRegSummary> =
  createEntityAdapter<SectorServiceRegSummary>({
    selectId: (x) => x?.sector?.id as any,
  });

export const initialState: State = {
  ministry: ministryAdapter.getInitialState(),
  sector: sectorAdapter.getInitialState(),
};

export const reducer = createReducer(
  initialState,
  on(A.clearMinistryServiceRegSummary, (s) => ({
    ...s,
    ministry: ministryAdapter.removeAll(s.ministry),
  })),
  on(A.upsertMinistryServiceRegSummary, (s, { rows }) => ({
    ...s,
    ministry: ministryAdapter.setAll(rows ?? [], s.ministry),
  })),
  on(A.clearSectorServiceRegSummary, (s) => ({
    ...s,
    sector: sectorAdapter.removeAll(s.sector),
  })),
  on(A.upsertSectorServiceRegSummary, (s, { rows }) => ({
    ...s,
    sector: sectorAdapter.setAll(rows ?? [], s.sector),
  }))
);
